<template>
	<div>家庭签约医生统计</div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>